export default __webpack_public_path__ + "static/3-4331edd60cc34f81c00e31212d98f356.jpeg";